import React, { useState, useEffect } from "react";
import Login from "../Components/Login/Login";
import LogoIcon from "../assets/logo-icon.png";
import VisionImg from "../assets/visionimage.png";
import VerifyOtp from "../Components/VerifyOtp/VerifyOtp";
import { getInviteDetails, LoginApi, RegisterCompanyApi } from "../api/api";
import Register from "../Components/Register/Register";
import { useParams } from "react-router-dom";

function LoginPage() {
  const [screen, setScreen] = useState("login");
  const [loading, setLoading] = useState(false);
  const [email, setEmail] = useState("");
  const [errorMsg, setErrormsg] = useState("");
  const [formInput, setFormInput] = useState({
    organization_name: "",
    email: "",
    mobile_number: "",
    website: "",
    industry_id: "665a3cfc6dd2f0d02f0a6b5e",
    gender: "",
    org_email: "",
    image: null,
    organization_location: [""],
  });
  console.log("formInput", formInput);

  const { id } = useParams();

  const getInvite = async () => {
    try {
      if (!id) return;
      // setLoading(true);
      const payload = {
        invitation_id: id,
      };
      const data = await getInviteDetails(payload);

      console.log(data?.data?.data?.email, "llll");

      setFormInput((form) => ({ ...form, email: data?.data?.data?.email }));
      setEmail(data?.data?.data?.email);
    } catch (err) {
      console.log(err);
    } finally {
      // setLoading(false);
    }
  };

  useEffect(() => {
    getInvite();
  }, []);

  const handleChange = (e) => {
    setErrormsg("");
    const { name, value } = e.target;
    setFormInput((prevDetails) => ({
      ...prevDetails,
      [name]: value,
    }));
  };

  const handleFileChange = (e) => {
    setErrormsg("");
    const { name, files } = e.target;
    setFormInput((prevDetails) => ({
      ...prevDetails,
      [name]: files[0], // File object (binary)
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const formData = new FormData();

      // Append each field to FormData
      for (const key in formInput) {
        if (formInput[key]) {
          formData.append(key, formInput[key]);
        }
      }
      formData.append("industry_id", "665a3cfc6dd2f0d02f0a6b5e");
      // formData.append(
      //   "locations",
      //   JSON.stringify(formInput.organization_location)
      // );

      const register = await RegisterCompanyApi(formData);

      if (register?.data?.status === true) {
        setEmail(formInput.email);
        setScreen("otp");
        setFormInput([]);
      } else {
        setErrormsg(register?.data?.message || "Something went wrong!");
      }
    } catch (error) {
      //console.log("error>catch", error);
      setErrormsg(error?.response?.data?.message || "Error occurred!");
    } finally {
      setLoading(false);
    }
  };

  const handleLoginSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const payload = {
      email: email,
    };
    try {
      const loginUser = await LoginApi(payload);

      // ////console("loginUser", loginUser);
      if (loginUser?.data?.status === true) {
        setScreen("otp");
      }
    } catch (error) {
      // Check for the 440 status code (or any other status codes)

      if (error.response) {
        //console.log("error", error.response);
        if (error.response.status === 401) {
          if (error.response.data.is_exist === false) {
            setErrormsg(error.response.data.message);
            setScreen("Add");
          }
          if (error.response.status === 400) {
            setErrormsg(error.response.data.message);
          }
        } else {
          setErrormsg(error.response.message);
        }
      }
    } finally {
      setLoading(false);
    }
    // setScreen("otp");
  };

  const onBack = () => {
    setScreen("login");
    setErrormsg("");
  };
  return (
    <>
      <section className="loginForm">
        <div className="container-fluid min-vh-100 d-flex align-items-center p-0">
          <div className="row m-0 w-100 min-vh-100">
            <div
              style={{ background: "#f4eeff" }}
              className="col-md-5 d-flex min-vh-100 flex-column justify-content-center align-items-center p-4"
            >
              <div className="mb-4">
                <img
                  src={LogoIcon}
                  alt="Logo"
                  style={{ width: "100px" }}
                  className="img-fluid"
                />
              </div>

              {/* <SocialLogin */}
              {/* //  handleSocialLoginResponse={(response) =>
                //      handleOTPSubmit(response)
                //      }
                // /> */}

              {screen === "login" && (
                <>
                  <div className="w-75">
                    <h3 className="title text-center">
                      Sign in to your account
                    </h3>
                    <div className="d-flex justify-content-center my-2">
                      <hr className="w-25 mx-2" />
                      <p>or continue with email</p>
                      <hr className="w-25 mx-2" />
                    </div>
                    <Login
                      handleLoginSubmit={handleLoginSubmit}
                      email={email}
                      setEmail={setEmail}
                      loading={loading}
                    />
                  </div>
                  <p>
                    <span className="text-danger">{errorMsg}</span>
                  </p>

                  <p className="resend">
                    Don't have an account?{" "}
                    <button className="" onClick={() => setScreen("Add")}>
                      Sign Up
                    </button>
                  </p>
                </>
              )}
              {screen === "otp" && <VerifyOtp email={email} onBack={onBack} />}
              {screen === "Add" && (
                <>
                  <div className="w-75">
                    <h3 className="title text-center">
                      Fill in & Get Started!
                    </h3>

                    <Register
                      formInput={formInput}
                      handleChange={handleChange}
                      handleSubmit={handleSubmit}
                      loading={loading}
                      handleFileChange={handleFileChange}
                    />
                  </div>
                  <p>
                    <span className="text-danger">{errorMsg}</span>
                  </p>
                </>
              )}

              {/* <p className="resend">
                Don't have an orgnaization?{" "}
                <Link className="" to={"/add-orgnaization"}>
                  Add
                </Link>
              </p> */}
            </div>

            <div className="col-md-7 d-none d-md-flex align-items-center justify-content-center">
              <div className="fromImage">
                <img
                  src={VisionImg}
                  alt="Right Section"
                  className="img-fluid"
                />
                <h2 className="mb-2">
                  Boost Productivity with AI Monitoring Tools
                </h2>
                <p>
                  AI tools productivity by tracking performance and optimizing
                  workflows
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default LoginPage;
